import { Component } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from '../../services/auth.service';
import { GrandTypeEnum } from '../../enums/grand-type-enum';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { User } from './../../models/user.model';
import { UserRoleEnum } from '../../enums/user-role-enum';
import { GoogleAuthComponent } from '../../layouts/google-auth/google-auth.component';

@Component({
  selector: 'login',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    GoogleAuthComponent,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
})
export class LoginComponent {
  returnUrl: string = '';
  loginForm: FormGroup;
  loggedUser: User = new User();

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService
  ) {
    this.loginForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ],
      ],
      password: ['', Validators.required],
    });

    this.returnUrl =
      this.route.snapshot.queryParams['returnUrl'] ||
      environment.DefaultReturnUrl;
  }

  onSubmit(): void {
    if (this.loginForm.valid) {
      this.spinner.show();
      const userInfo = {
        ...this.loginForm.value,
        grand_type: GrandTypeEnum.Credentials,
      };

      this.authService.authenticate(userInfo).subscribe(
        (response) => {
          this.spinner.hide();
          this.loggedUser = this.authService.CurrentUserValue;
          this.returnUrl =
            this.loggedUser.role == UserRoleEnum.MasterAdmin
              ? environment.DefaultRetrunUrlForMasterAdmin
              : this.returnUrl;
          this.router.navigateByUrl(this.returnUrl);
        },
        (error: any) => {
          this.toastr.error(error.error.message.Text, 'Login');
          this.spinner.hide();
          console.error(error.error.message);
        }
      );
    } else {
      this.loginForm.markAllAsTouched();
    }
  }
}
